import React from 'react'
import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../utils/motion";
import heroImage from '/image_bground.webp'
import vivaceLogo from "/vivace_logo.webp"

// Home section with responsive layout, animations, and mobile/desktop variations
const Home = () => {
	return (
		<section id="home" className="flex flex-col lg:flex-row items-center pt-30 lg:pt-10 pb-16 lg:mb-15 mx-8 ">

			{/* Mobile-only Right Column (Logo + Image) */}
			<motion.div
				variants={fadeIn('left', 0.5)}
				initial="hidden"
				whileInView="show"
				className="lg:hidden w-full lg:w-1/2 mt-16 md:mt-0 pl-0 "
			>
				{/* Mobile animated title */}
				<motion.h1
					variants={textVariant(0.3)}
					initial="hidden"
					whileInView="show"
					className="text-4xl md:text-5xl lg:text-6xl text-blue-400 leading-tight"
				>
					<div className="flex flex-row justify-center mb-5 gap-5">
						<img src={vivaceLogo} className="w-18 h-18 rounded-full opacity-90" alt="Vivace International"/>
						Vivace International
					</div>
				</motion.h1>

				{/* Mobile hero image */}
				<div className="relative w-full">
					<img
						src={heroImage}
						alt="Team meeting"
						className="rounded-lg w-full h-[400px] sm:h-[500px] md:h-[600px] opacity-90 mix-blend-multiply relative z-10 hover:scale-105 transition-transform duration-300 object-cover"
					/>
				</div>
			</motion.div>

			{/* Left Column */}
			<div className="w-full lg:w-1/2 space-y-8 flex flex-col items-center lg:items-start mb-5 lg:pl-50">

				{/* empty animation wrapper if needed */}
				<motion.div variants={fadeIn('right', 0.2)} initial="hidden" whileInView="show"></motion.div>

				{/* Desktop animated title */}
				<motion.h1
					variants={textVariant(0.3)}
					initial="hidden"
					whileInView="show"
					className="hidden lg:block text-4xl md:text-5xl lg:text-6xl  text-blue-400 leading-tight"
				>
					<div className="flex flex-row gap-5">
						<img src={vivaceLogo} className="w-18 h-18 rounded-full opacity-90" alt="Vivace International"/>
						Vivace International
					</div>
				</motion.h1>

            <div className="flex flex-col gap-8 mt-8 justify-center lg:items-start">
				{/* Subheading */}
				<motion.p
					variants={fadeIn('up', 0.4)}
					initial="hidden"
					whileInView="show"
					className="text-gray-600 text-3xl max-w-lg"
				>
					A Multi-Product Company
				</motion.p>

				{/* Description */}
				<motion.p
					variants={fadeIn('up', 0.4)}
					initial="hidden"
					whileInView="show"
					className="text-gray-600 text-2xl max-w-lg"
				>
					Get the most accurate leads, sales people and conversions, tools and more — all within the same one billing.
				</motion.p>

				{/* Email form + button block */}
				<motion.div
					variants={fadeIn('up', 0.5)}
					initial="hidden"
					whileInView="show"
					className="flex-row gap-3 max-w-md"
				>

	
				</motion.div>
			</div>
				</div>

			{/* Desktop-only Right Column */}
			<motion.div
				variants={fadeIn('left', 0.5)}
				initial="hidden"
				whileInView="show"
				className="w-full lg:w-1/2 lg:mt-16 pr-5"
			>
				<div className="relative w-full">
					<img
						src={heroImage}
						alt="Team meeting"
						className="hidden lg:block rounded-lg w-full h-[400px] 
						 md:h-[650px] opacity-90 mix-blend-multiply relative z-10 hover:scale-105 transition-transform duration-300 object-cover"
					/>
				</div>
			</motion.div>

		</section>
	)
}

export default Home
